import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ThumbsDown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 22.697c-.2-2.098-.6-4.196-1.1-6.294-.1-.5-.2-.999-.4-1.498-.4-1.499-.7-2.997-1-4.595-.1-.4-.1-.8-.2-1.2-.3-1.597-.5-3.396-1.3-4.994-.5-1.199-1.3-1.998-2.3-2.497-.9-.5-2-.7-3.1-.8-6.6-.4-13.4.9-19.6 2.598V1.419c0-.6-.5-1-1-1H3c-.5 0-1 .5-1 1v28.07c0 .6.5 1 1 1h9c.6 0 1-.5 1-1v-1.098l3.7 2.997c2.6 2.097 4.3 4.994 4.6 8.191 0 .4.1.7.1 1.099v.5c0 2.197 2.2 3.895 4.3 2.996 3.3-1.298 5.6-4.495 5.6-8.191 0-1.898-.5-3.696-1.4-5.295L28 27.292h9.8c2.2 0 4.1-1.798 4.1-4.096.1-.2.1-.3.1-.5ZM11 28.49H4.1V2.518H11V28.49Zm26.9-3.297H26.3c-.4 0-.7.2-.9.5-.2.3-.2.699 0 .998l2.7 4.895a9.143 9.143 0 0 1 1.1 4.296c0 2.897-1.8 5.294-4.3 6.293-.7.3-1.5-.3-1.5-1.099v-.499c0-.4 0-.8-.1-1.299-.3-3.796-2.4-7.292-5.3-9.59l-5-3.995V5.514c6.3-1.698 13-2.996 19.4-2.597 1 .1 1.8.2 2.3.5.6.3 1 .7 1.4 1.498.6 1.299.8 2.697 1.1 4.296.1.5.2.999.2 1.398.3 1.599.7 3.097 1 4.695l.3 1.499c.5 1.998.9 4.096 1.1 6.093.2 1.3-.7 2.298-1.9 2.298Z"
  }));
});
ThumbsDown.displayName = 'ThumbsDown';
ThumbsDown.defaultProps = {
  'aria-label': 'ThumbsDown'
};
export default ThumbsDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ThumbsDown.js
// module id = 3933
// module chunks = 11